const RASTER_BASE_URL = `${process.env.REACT_APP_MAPPER_DISPLAY_BASEURL_V1}/raster`;

export const RASTER_LAYER_KEYS = ["biomass", "forest", "grassland", "shrubland"];

const makeRasterConfig = (key, { opacity = 0.8, maxzoom = 22 } = {}) => ({
  id: key,
  type: "raster",
  sourceId: `raster-${key}`,
  source: {
    type: "raster",
    tiles: [`${RASTER_BASE_URL}/${key}/tiles/{z}/{x}/{y}.webp`],
    tileSize: 256,
    minzoom: 0,
    maxzoom,
  },
  layers: [
    {
      id: `raster-${key}-layer`,
      type: "raster",
      source: `raster-${key}`,
      paint: {
        "raster-opacity": opacity,
        "raster-fade-duration": 0,
      },
    },
  ],
});

export const terrainRasterTileConfig = Object.fromEntries(
  RASTER_LAYER_KEYS.map((key) => [key, makeRasterConfig(key)])
);